import './App.css';
import CodeForm from './Components/CodeForm'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        
      </header>
      <div id='center-container'>
        <div id='hero-img'></div>
        <div id='interactive-section'>
          <h1>Russell Dickerson</h1>
          {/* <h1>Same Truck</h1> */}
          <hr></hr>
          <CodeForm />
        </div>
      </div>
    </div>
  );
}

export default App;
